export default __webpack_public_path__ + "static/leaf-bg-fff81e8fda67abf1bcd33030ed240e83.png";